import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	componentDidMount() {
		const queryString = window.location.search;
		const params = new URLSearchParams(queryString);
		const data = params.get('redirect');
		if (data === 'off') {
			return super.componentDidMount?.();
		}
		if (navigator?.language?.includes('fr')) {
			window.location.replace('https://www.portailceleste.ca');
			return;
		}
		return super.componentDidMount?.();
	}

}
